import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { toolsDetailsNCFileConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const ToolsDetailsNCFileStack = createStackNavigator();

const ToolsDetailsNCFileNavigator = () => {
  return (
    <ToolsDetailsNCFileStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {toolsDetailsNCFileConfig.map(({ Component, name }) => (
        <ToolsDetailsNCFileStack.Screen key={name} name={name} component={Component} />
      ))}
    </ToolsDetailsNCFileStack.Navigator>
  );
};

export { ToolsDetailsNCFileNavigator };
